<template>
  <a-modal
    class="familyModal"
    v-bind="options"
    @ok="handleOk"
    @cancel="handleCancel">
    <div class="setting-wrap">
      <p>
        <span class="title">申请号合并规则</span>
        <a-tooltip placement='bottomLeft' overlayClassName='tooltipsClass'>
          <template slot="title">
            一件专利在其生命周期中可能被多次公开，产生不同的公开文本，可通过公开日设置保留一篇公开文本。
          </template>
          <my-icon class="my-icon my-icon-question" type='icon-prompt-fill'></my-icon>
        </a-tooltip>
      </p>
      <Form class="form-1" ref="form1" layoutType="grid" :optionList="formRow1" :defaultModel="defaultValue"></Form>
      <p>
        <span class="title">同族号合并规则</span>
        <a-tooltip placement='bottomLeft' overlayClassName='tooltipsClass'>
          <template slot="title">
            每组同族专利将按照设定的合并规则顺序保留一篇公开文本。如果同一时间有多个文本公开，则会按照优先显示的公开国顺序取代表文本；
            如果同—国家有多个文本公开或者没有匹配到优先显示的公开国，则会按照设定的时间顺序取代表文本。
          </template>
          <my-icon class="my-icon my-icon-question" type='icon-prompt-fill'></my-icon>
        </a-tooltip>
      </p>
      <Form ref="form2" layoutType="grid" :optionList="formRow" :defaultModel="defaultValue"></Form>
    </div>
  </a-modal>
</template>

<script>
import Form from '@/views/backstageSupport/components/formTable/form.vue'
import {formRow, formRow1} from './configs/index'
export default {
  props: {
    customOpt: Object,
    defaultValue: Object
  },
  data() {
    return {
      formRow,
      formRow1,
      options: {
        title: '设置',
        width: 590,
        visible: false,
        loading: false,
        centered: true,
        // contentTips: '我是内容'
      },
      // defaultValue: {
      //   publicOrder: 1,
      //   timeOrder: 'publicOrder-1',
      //   ruleOrder: 2,
      //   showOrder: '' // 显示顺序
      // },
      sourceOptions: { // 事件的点击来源.主要用于指向用户点击ok后的去处
        source: '', // 去处
        params: {} // 参数
      }
    }
  },
  components: {
    Form
  },
  watch: {
    customOpt: {
      handler(nVal) {
        if (nVal) {
          // this.initDefaultModel() // 初始化默认值
          Object.assign(this.options, { ...this.customOpt })
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 初始化默认值
    // initDefaultModel() {
    //   const specialDeal = ['AMultipleSelect']
    //   const temp = this.formRow.concat(this.formRow1)
    //   temp.forEach(item => {
    //     if(specialDeal.includes(item.prop)) {
    //       item.forEach(i => {
    //         if(Object.hasOwnProperty.call(this.defaultValue, item.prop)) {
    //           this.defaultValue[i.prop] = i.defaultValue || ''
    //         }
    //       })
    //     } else {
    //       if(Object.hasOwnProperty.call(this.defaultValue, item.prop)) {
    //           this.defaultValue[item.prop] = item.defaultValue || ''
    //       }
    //     }
    //   })
    //   console.log(this.defaultValue)
    // },
    handleOk() {
      this.handlerVisible(false, this.sourceOptions)
      const form1 = this.$refs.form1.formModel
      const form2 = this.$refs.form2.formModel
      const result = Object.assign(form1, form2)
      this.$emit('ok', result)
    },
    handleCancel() {
      this.handlerVisible(false)
      this.$emit('cancel')
    },
    // 是否展示加载中的动画
    showLoading(v) {
      this.options.loading = v
    },
    // 处理弹窗是否显示
    handlerVisible(v, sourceOptions) {
      this.sourceOptions = sourceOptions
      this.options.visible = v
    }
  }
}
</script>
